export default "__VITE_ASSET__febe6820__"